export default __webpack_public_path__ + "static/media/picture.30bcabc0.jpeg";